import React from 'react';

export const orderCashPickUpConfig = [
  {
    path: '/order-cash-pick-up',
    component: React.lazy(() => import('./listing/listing')),
  },
  {
    path: '/order-cash-pick-up/add',
    component: React.lazy(() => import('./add/add')),
  },
  {
    path: '/order-cash-pick-up/immediate/add',
    component: React.lazy(() => import('./addImmediate/add')),
  },
  {
    path: '/order-cash-pick-up/edit',
    component: React.lazy(() => import('./edit/edit')),
  },
  {
    path: '/order-cash-pick-up/immediate/edit',
    component: React.lazy(() => import('./editImmediate/edit')),
  },
  {
    path: '/order-cash-pick-up/view',
    component: React.lazy(() => import('./view/view')),
  },
  {
    path: '/order-cash-pick-up/immediate/overview',
    component: React.lazy(() => import('./overviewImmediate/overview')),
  },
];
